import { get } from 'lodash';
import { connect } from 'react-redux';
import {
  getProposals,
  getCurrentResort,
  getSelectedProposalId,
  getDetailedAttendees,
  getSuggestions,
} from 'Store/booking/booking.selector';
import type { BookingEngineEntry } from 'Store/booking/constants';
import 'Store/booking/constants';
import {
  clearProposals,
  fetchProposalsAndRedirect,
  prepareBe,
} from 'Store/booking/proposals/proposals.action';
import {
  selectProposal,
  clearSelectedProposal,
} from 'Store/booking/selected-proposal-id/selectedProposalId.action';
import { setCms } from 'Store/cms/cms.actions';
import { endLoading, startLoading } from 'Store/global-loader/globalLoader.action';
import { DEFAULT_TRIP_DURATION } from 'Store/trip-criteria/duration/duration.constants';
import { setDepartureDate } from 'Store/trip-criteria/departure-date/departureDate.action';
import { getDepartureCity, getTripDuration } from 'Store/trip-criteria/tripCriteria.selector';
import { getArrivalDate, getDepartureDate } from 'Store/trip-date-criteria/storeHelper';
import { updateTripDateCriteria } from 'Store/trip-date-criteria/tripDateCriteria.action';
import { setAttendees } from 'Store/trip-information/adults/adults.action';
import { DEFAULT_ADULTS_NB } from 'Store/trip-information/adults/constants';
import { getKids, getAdults, tripInformationSelector } from 'Store/trip-information/storeHelper';
import { getResortInitialKids } from 'Utils/trip-information/tripInformationUtils';
import { QUERY_TRANSPORT } from 'Utils/uri/constants';
import BookingEngineForm from './BookingEngineForm';

function getValue<T>(value: T | null | undefined, initialValue: T): T | null | undefined {
  return !value && initialValue ? initialValue : value;
}

function getQueryParamValue(name: string, queryParams) {
  return get(queryParams, name);
}

type ComponentProps = {
  bookingCriteria?: {
    initialNumberOfChildren?: number;
    initialNumberOfAdults?: number;
    initialDuration?: number;
    initialTransport?: string;
    departureCities?: Array<{
      value: string;
    }>;
  };
  queryParams: Record<string, any>;
  resort: Partial<Product>;
};
type ContainerProps = {
  adultsNumber: number;
  arrivalDate: number | null | undefined;
  // parseInt de "YYYYMMDD"
  bookingEngineEntry: BookingEngineEntry;
  departureDate: number | null | undefined;
  // parseInt de "YYYYMMDD"
  departureCity: string | null | undefined;
  duration: number;
  kids: Array<any>;
  proposals: Array<Proposal>;
};

function getValidDepartureCity(
  state: ReduxState,
  props: ComponentProps,
): string | null | undefined {
  const availableTransports = props?.bookingCriteria?.departureCities || [];
  const transportIATACodes = availableTransports.map((t) => t.value);
  const departureCity =
    getDepartureCity(state) || getQueryParamValue(QUERY_TRANSPORT, props.queryParams);
  return transportIATACodes.includes(departureCity) ? departureCity : '';
}

export function mapStateToProps(state: ReduxState, props: ComponentProps): ContainerProps {
  const kids = getKids(state);
  const adults = getAdults(state).length;
  const duration = getTripDuration(state);
  const departureCity = getValidDepartureCity(state, props);
  const departureDate = getDepartureDate(state);
  return {
    adultsNumber:
      getValue(adults, props?.bookingCriteria?.initialNumberOfAdults) || DEFAULT_ADULTS_NB,
    arrivalDate: getArrivalDate(state),
    bookingEngineEntry: state.booking.bookingEngineEntry,
    departureDate,
    departureCity,
    duration: getValue(duration, props?.bookingCriteria?.initialDuration) || DEFAULT_TRIP_DURATION,
    kids: getResortInitialKids(
      kids,
      get(props, 'bookingCriteria.initialNumberOfChildren'),
      get(props, 'resort.adultOnly'),
    ),
    proposals: getProposals(state),
    selectedProposalId: getSelectedProposalId(state),
    resort: { ...getCurrentResort(state), ...props.resort },
    attendees: getDetailedAttendees(state),
    tripInformation: tripInformationSelector(state),
    suggestions: getSuggestions(state),
  };
}
export const mapDispatchToProps = {
  clearProposals,
  endLoading,
  startLoading,
  updateTripDateCriteria,
  setDepartureDate,
  clearSelectedProposal,
  selectProposal,
  fetchProposalsAndRedirect,
  setCms,
  setAttendees,
  prepareBe,
};
export default connect(mapStateToProps, mapDispatchToProps)(BookingEngineForm);
